import './script-personalblock.js';
import './script-personalmessages.js';
import './script-poll.js';
import './script-tooltip.js';
import './script-topics.js';
import './script-user.js';
import _ from 'underscore';
import Swal from 'sweetalert2'


$('.content_container__button a').on('click', function (e) {
    e.preventDefault();
    toggle_sidebar('onclick');
});

$(document).ready(function () {
    resetFooterLinks();
});



function skyscraperTop() {
    var contentCont = $('.content_container');
    var contentTop = contentCont.offset();
    var SkyScraper = $('#skyscraper');
    if (SkyScraper.length && contentCont.length) {
        SkyScraper.css({'top': contentTop.top - 95 + 500});
    }
}

function toggle_sidebar(source) {
    var $content = $('#content');
    var $sidebar = $('#sidebar');
    var $account_div = $('.js-myaccount');

    $content.toggleClass('content_container__content--full');
    $sidebar.toggleClass('content_container__sidebar--hidden');
    $('.content_container__button a i').toggleClass('fa-sidebar--hidden');
    $('.inner_sidebar .hide_trigger').toggle();

    if (supports_local_storage() && $account_div.length) {
        var user_id = getUserIdFromDiv();
        var first_click_id = 'first_click_' + user_id;
        var sidebar_pos_id = 'sidebar_pos_' + user_id;

        if ($sidebar.width() <= 1) {

            if (!localStorage.getItem(first_click_id)) {

                var first_click = new Date();
                first_click.setHours(first_click.getHours() + 24);
                localStorage[first_click_id] = first_click;

            }

            localStorage[sidebar_pos_id] = 'collapsed';

        } else {

            localStorage.removeItem(sidebar_pos_id);

        }

    }
}

$('.block__readmore').on('click', function () {
    $('.forum__expand').slideToggle('slow');
});

$('.btn__back-top').on('click', function () {
    $('html, body').animate({scrollTop: 0}, 600);
});

$('#moveToEditor').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#qr_postform').offset().top
    }, 600);
    return false;
});

$('.pagination-search > a').click(function (e) {
    e.preventDefault();
});

$('.modpanel').on('click', function (e) {
    e.preventDefault();
    var $target = $('.dropdown__modpanel');

    $target.slideToggle(450);
});

$('.expand__reply').on('click', function (event) {
    $(event.currentTarget).find('.form__reply').slideDown(450);
});

// table preview popup.
var tableHtml = '<div class=\'table-creator\'><span class=\'close-creator\'></span>';
tableHtml += '<div class=\'top__section\'>';
tableHtml += '<div class=\'select-one\'><p class=\'select-info\'>Aantal rijen:</p>';
tableHtml += '<select class=\'row__amount\' name=\'rows\'>';
for (var i = 0; i < 11; i++) {
    if (i === 3) {
        tableHtml += '<option selected>' + i + '</option>';
    } else {
        tableHtml += '<option>' + i + '</option>';
    }
}
tableHtml += '</select></div>';

tableHtml += '<div class=\'select-two\'><p class=\'select-info\'>Aantal kolommen:</p>';
tableHtml += '<select class=\'column__amount\' name=\'colums\'>';
for (var i = 0; i < 11; i++) {
    if (i === 3) {
        tableHtml += '<option selected>' + i + '</option>';
    } else {
        tableHtml += '<option>' + i + '</option>';
    }
}
tableHtml += '</select></div>';

tableHtml += '</div>';

tableHtml += '<div class=\'bottom__section\'>';
tableHtml += '<p class=\'example\'>Selecteer eerst het gewenste aantal rijen en kolommen, vul daarna de invoervelden in.</p>';
tableHtml += '<table class=\'body__table\'></table>';
tableHtml += '<button class=\'button\'>Tabel toevoegen</button>';
tableHtml += '</div>';

tableHtml += '</div>';

$('.form__toolbar span').on('click', function (event) {
    if ($(this).attr('value') === 'table' && $(window).width() >= 768) {
        $('html').addClass('focus');
        $('body').addClass('focus').append(tableHtml);
        setTimeout(function () {
            buildTable(3, 3);
        }, 600);
    }
});

var table = '';
var columnStructure = '';
var newColumnStructure = [];
var valueCollector = [];

function buildTable(rows, columns) {

    columnStructure = '<th><input type=\'text\' class=\'table-input\'></th>';
    var rowsHtml = '';
    var columnsHtml = '';

    if ($('body .table-creator .body__table').length > 0) {
        $('body .table-creator .body__table').empty();
    }

    // build extra for output later on
    var amount = rows * columns;
    for (i = 1; i < (amount + 1); i++) {
        newColumnStructure.push('<th><input type="text" number="' + i + '"></th>');
    }

    for (i = 0; i < columns; i++) {
        columnsHtml += columnStructure;
    }

    for (i = 0; i < rows; i++) {
        if (i === 1) {
            columnsHtml = columnsHtml.replace(/th/g, 'td');
        }

        rowsHtml += '<tr>' + columnsHtml + '</tr>';
    }

    table = rowsHtml;

    $('body .table-creator .body__table').append(table);

    i = 1;

    $('body .table-creator .body__table .table-input').each(function (event) {
        $(this).attr('number', i++);
        if (valueCollector[(i - 2)]) {
            $(this).val(valueCollector[(i - 2)]);
        }
    });
}

$('body').on('click', '.close-creator', function () {
    $('.table-creator').remove();
    $('body').removeClass('focus');
    $('html').removeClass('focus');

    valueCollector.length = 0;
});

$('body').on('keydown', '.table-input', function (event) {
    if (event.which === 13) {
        var index = $('.table-input').index(this) + 1;
        $('.table-input').eq(index).focus();
    }
});

$('body').on('keyup', '.body__table .table-input', function (event) {
    var currentNumber = $(this).attr('number') - 1;
    newColumnStructure[currentNumber] = $(this).val();

    valueCollector[$(this).attr('number') - 1] = $(this).val();
});

$('body').on('click', '.table-creator .button', function (event) {
    $('.table-creator').remove();
    $('body').removeClass('focus');
    $('html').removeClass('focus');

    tableExport(rowAmount, columnAmount);

    valueCollector.length = 0;
});

var rowAmount = 3;
var columnAmount = 3;

function tableExport(rows, columns) {

    var rowsHtml = '';

    var total = rows * columns;
    var newCount = 0;

    for (i = 0; i < total; i++) {

        if (i === 0) {
            rowsHtml += '<tr>';
        }

        if (newCount == columns) {
            newCount = 0;
            rowsHtml += '</tr>\n';
            rowsHtml += '<tr>';
        }

        if (newColumnStructure[i].includes('<input')) {
            if (i >= columns) {
                newColumnStructure[i] = '<td></td>';
            } else {
                newColumnStructure[i] = '<th></th>';
            }
            rowsHtml += newColumnStructure[i];
        } else {
            if (i >= columns) {
                newColumnStructure[i] = '<td>' + newColumnStructure[i] + '</td>';
            } else {
                newColumnStructure[i] = '<th>' + newColumnStructure[i] + '</th>';
            }
            rowsHtml += newColumnStructure[i];
        }

        newCount++;
    }

    table = rowsHtml;

    var textareaTable = $('.form__item textarea');

    var caretPos = textareaTable.selectionStart;
    var textAreaTxt = textareaTable.val().replace('[table][/table]', '');
    var txtToAdd = '[table]\n' + table.replace(/\</g, '[').replace(/\>/g, ']') + '[/tr]\n[/table]';

    jQuery(textareaTable).val(textAreaTxt.substring(0, caretPos) + txtToAdd);
}

$('body').on('change', '.row__amount, .column__amount', function (event) {

    if ($(this).attr('name') === 'rows') {
        rowAmount = $(this).val();
    } else {
        columnAmount = $(this).val();
    }

    buildTable(rowAmount, columnAmount);

});

var body = $('body');

$('.featured-holder').each(function (event) {
    var $self = $(event.currentTarget);
    var url = $self.attr('data-viva-url');

    if (url) {
        $.get(url, function (html) {
            $self.find('.replacer').replaceWith(html);
        });
    }
});

$('.featured-holder__header').on('click', '.menu-toggle', function (event) {
    event.preventDefault();
    $(body).toggleClass('body--mobile-active');
});

if ($(window).width() < 1024) {
    $('.profile > a').on('click', function (e) {
        e.preventDefault();
        $('.profile .profile__drop').fadeToggle(250);
        $('.profile__drop span').width($(window).width());
    });
}

$('.thread__forum span').on('click', function (e) {
    e.preventDefault();
    $('.thread__description').slideToggle(450);
});

if ($('.header__row, .author__block, .thread__posts .post').length > 0) {

    $('.back-to-bottom').addClass('active');

    $(function (event) {
        $(window).on('mousewheel touchmove', function (event) {

            if ($(document).scrollTop() > 120) {
                $('.back-to-top').addClass('active');
            }

            if ($(document).scrollTop() < (screen.height - 120)) {
                $('.back-to-bottom').addClass('active');
            }
        });

    });

    $('body').on('click', '.back-to-bottom', function (event) {
        let firstFooterOffset = $('.btn__back-top').offset().top - 10;
        if ($('.thread__posts .post:visible').length > 0) {
            if ($('.readmore:visible').length > 0) {
                // mobile only solution. Makes sure the readmore button is within screen view after pushing 'back to bottom' button;
                firstFooterOffset = $('.readmore').offset().top - $('.thread__posts .post:visible').last().height() - (screen.height / 2);
            } else {
                firstFooterOffset = $('.thread__posts .post__bottom').last().offset().top - $('.thread__posts .post:visible').last().height();

            }
        }
        $('html, body').animate({scrollTop: firstFooterOffset}, 'slow');
        $('.back-to-top').addClass('active');
    });

    $('body').on('click', '.back-to-top', function (event) {
        $('html, body').animate({scrollTop: 0}, 'slow');
        $('.back-to-bottom').addClass('active');
        $('.back-to-top').removeClass('active');
    });

}

$('.pijler__dropdown_menu').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    var $target = $('.dropdown__pijler');
    $target.slideToggle(450);
});

$('.markCheckbox').on('click', function (e) {

    e.preventDefault();
    e.stopPropagation();

    var self, target, input, val;

    self = $(event.currentTarget);
    target = self.parent('.form__row').find('.niceCheckbox');
    input = self.parent('.form__row').find('input[type="checkbox"]');

    if (target.hasClass('checked')) {
        target.removeClass('checked');
        val = input.data('off');
    } else {
        target.addClass('checked');
        val = input.data('on');
    }

    updateOption(input.data('option'), val, '/ucp/update/option', false);
});

$('.prefSelect').on('change', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $self, option, val;

    $self = $(event.currentTarget);
    option = $(this).data('option');
    val = $(this).val();

    updateOption(option, val, '/ucp/update/option', false);
});

$('#saveSig').on('click', function (e) {
    e.preventDefault();
    var signature = $('.sig').val();
    updateOption('user_sig', signature, '/ucp/update/option', true);
});

var updateOption = function (option, value, route, reload) {
    var $status = $('.form__status');

    /*
     * Make sure we don't update all fields.
     */
    let allowedUpdates = [
        'user_sig',
        'user_birthday',
        'user_topic_show_days',
        'user_post_show_days',
        'user_topic_sortby_dir',
        'user_post_sortby_dir',
        'user_allow_pm'
    ];

    if (allowedUpdates.includes(option)) {
        $.ajax({
            url: route,
            data: {option: option, value: value},
            dataType: 'json',
            type: 'POST',
            success: function () {
                if (reload === true) {
                    location.reload();
                } else {
                    $status.slideDown(450);
                    setTimeout(function () {
                        $status.slideUp(550);
                    }, 1500);
                }
            },
        });
    }
};

$('.foe__action').on('click', function () {
    var $self = $(event.currentTarget);
    var $target = $self.parent('.form__foe');
    setTimeout(function () {
        $target.slideUp(450);
    }, 1000);
});

// no need for this on a 404, page ( no sidebar there )
var check = document.getElementsByClassName('error404');
if (!check) {
    fixedAd(document.getElementById('sidebar-rectangle-2'), topOffset, true);
}

// find top position of object
function findPosTop(obj) {
    var curtop = 0;
    // if object has parent
    if (obj.offsetParent) {
        // loop through parents recursively
        do {
            // check if top offset is numeric
            if (!isNaN(obj.offsetTop)) {
                curtop += obj.offsetTop;
            }
        } while (obj = obj.offsetParent);

        return curtop;
    }
}

/**
 * Apply code editor to all textarea elements with data-bbcode attribute
 */
(function ($) {

    $('textarea[data-bbcode]').each(function () {
        phpbb.applyCodeEditor(this);
    });

    phpbb.registerPageDropdowns();

    $('#color_palette_placeholder').each(function () {
        phpbb.registerPalette($(this));
    });

    // Update browser history URL to point to specific post in viewtopic.php
    // when using view=unread#unread link.
    phpbb.history.replaceUrl($('#unread[data-url]').data('url'));

    // Hide settings that are not selected via select element.
    $('select[data-togglable-settings]').each(function () {
        var $this = $(this);

        $this.change(function () {
            phpbb.toggleSelectSettings($this);
        });
        phpbb.toggleSelectSettings($this);
    });

})(jQuery);

/**
 * Workaround to avoid duplicate headers and footers being loaded
 */
(function ($) {
    $('header').not(':first').hide();
    $('.primary-footer').not(':first').hide();
})(jQuery);

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function checkCookie(cname) {
    var cookie_val = getCookie(cname);
    if (cookie_val !== '') {
        return cookie_val;
    } else {
        return false;
    }
}

function getUserIdFromDiv() {
    var myAccount = $('.js-myaccount');
    var userId = '1';
    if (myAccount.length) {
        userId = myAccount.attr('js-data-userid');
    }
    return userId;
}
/**
 * JavaScript read posts scripts
 *
 * @return boolean
 */
(function ($) {
    var seperator = '::';
    var account_div = $('.js-myaccount');
    if (supports_local_storage() && account_div.length) {

        var reading_posts = _.debounce(read_posts, 1000);
        $(window).scroll(reading_posts);

        var user_id = getUserIdFromDiv();

        if (localStorage.getItem('last_read_posts_' + user_id) !== null) {
            var loaded_topic_posts = JSON.parse(localStorage['last_read_posts_' + user_id]);

            $('.topic__item a , .active__item h4 a').not('.topic__meta a').each(function () {
                var $topic_url = $(this);
                var $url = $topic_url.attr('href');

                if ($url.indexOf('t=') !== -1) {

                    var topic_id_url = $url.split('t=');

                    if (topic_id_url[1].indexOf('&p') !== -1) {

                        var topic_id = topic_id_url[1].split('&p');

                        if (topic_id[0].indexOf('&sid')) {
                            var topic_id_sid = topic_id[0].split('&sid');
                            topic_id[0] = topic_id_sid[0];

                        }

                        loaded_topic_posts.forEach(function ($item, $index) {
                            var items = $item.split(seperator);
                            if (items[0] === topic_id[0]) {
                                if ($url.indexOf('&') !== -1 || $url.indexOf('?') !== -1) {
                                    $topic_url.attr('href', $url + '&p=' + encodeURIComponent(items[1]) + '#a' + items[1]);
                                } else {
                                    $topic_url.attr('href', $url + '?p=' + encodeURIComponent(items[1]) + '#a' + items[1]);
                                }
                            }
                        });
                    }
                }
            });
        }

    }

})(jQuery);

/**
 * JavaScript read posts with you
 * Saves the last post_id if partly visible in viewport to localStorage
 * Checks localStorage for existing thread ids and adds or removes if needed.
 *
 * @return boolean
 */
function read_posts() {
    var seperator = '::';
    var $posts = $('.post:visible');

    if ($posts.length) {
        var user_id = getUserIdFromDiv();

        var thread_id = $('.thread.row--margin').attr('data-id');
        var post_id = '';

        $posts.each(function () {
            if ($('#' + $(this).attr('id')).visible(true)) {
                post_id = $(this).attr('id');
            }
        });
        post_id = (post_id.length && post_id[0] === 'p') ? post_id.slice(1) : post_id;

        if (localStorage.getItem('last_read_posts_' + user_id) !== null) {

            var last_read_posts = JSON.parse(localStorage['last_read_posts_' + user_id]);

            last_read_posts.forEach(function ($item, $index) {
                var items = $item.split(seperator);
                if (thread_id === items[0]) {
                    last_read_posts.splice($index, 1);
                }
            });

            last_read_posts.push(thread_id + seperator + post_id);

        } else {
            last_read_posts = [];
            last_read_posts.push(thread_id + seperator + post_id);
        }

        localStorage['last_read_posts_' + user_id] = JSON.stringify(last_read_posts);
    }

}

/**
 * JavaScript check support localStorage
 *
 * @return boolean
 */
function supports_local_storage() {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
}

function waitForElement(elementPath, callBack) {
    window.setTimeout(function () {
        if ($(elementPath).length) {
            callBack(elementPath, $(elementPath));
        } else {
            waitForElement(elementPath, callBack);
        }
    }, 500);
}

$().ready(function () {
    // Sidebar hide settings;
    var $account_div = $('.js-myaccount');

    if (supports_local_storage() && $account_div.length) {

        var user_id = getUserIdFromDiv();
        var first_click_id = 'first_click_' + user_id;
        var sidebar_pos_id = 'sidebar_pos_' + user_id;

        //check if past expiration date
        var values = localStorage.getItem(first_click_id);

        if (new Date(values) < new Date()) {
            localStorage.removeItem(first_click_id);
            localStorage.removeItem(sidebar_pos_id);
        }

        if (localStorage.getItem(sidebar_pos_id) === 'collapsed') {
            toggle_sidebar('onload');

        }
    }

});

// Anonymize confirmation
// Swal = sweetalert2 popup box
$().ready(function () {

    $('body').on('click', '.profile__options > a.js-anonymize-member', function (e) {
        e.preventDefault();
        const url = $(this).attr('href');
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover the anonymized user!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, anonymize it!',
            cancelButtonText: 'No, keep it',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        }).then(function (result) {
            if (result.value) {
                document.location.href = url;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    'Cancelled',
                    'Nothing anonymized, the user is save :)',
                    'error'
                );
            }
        });

    });
});


var $window = $(window);

// this ensures all viva.nl footer links are opened in a new tab
function resetFooterLinks() {
    $('.footer__item:not(.popup)>a').each(
        function () {
            this.setAttribute('target', '_blank');
        }
    );
}

$(document).ready(function ($) {
    var hash = window.location.hash;
    if (hash === '' || hash === '#' || hash === undefined) {
        return false;
    }
    var header = $('.featured-holder__header');
    var target = $(hash);
    target = target.length ? target : $('[name=' + hash.slice(1) + ']');
    if (target.length > 0) {
        $('html,body').stop().animate({
            scrollTop: target.offset().top - header.outerHeight(true)
        }, 'linear');
    }
});
